export const minOdd = 1.01;
export const defaultMinOdd = 2;
export const defaultJetIndex = 0;
export const autoCashOutMaxOdd = 10000;
export const reconnectTabChangeDelay = 3000;

export const additionalBetAmountChangingButtons = {
  typing: 'typing',
  plus: 'plus',
  minus: 'minus',
  min: 'min',
  max: 'max',
  allIn: 'allIn',
  double: 'double',
  divide: 'divide',
};

export const betSectionTabsName = {
  manual: 'manual',
};

export const numPadSectionName = {
  ...betSectionTabsName,
  autoCashOutOdd: 'autoCashOutOdd',
};

export const autoCashOutDataKeys = {
  isOpened: 'isOpened',
  isBlurred: 'isBlurred',
  autoCashOutOdd: 'autoCashOutOdd',
  isValidatedOdd: 'isValidatedOdd',
  autoCashOutMaxOdd: 'autoCashOutMaxOdd',
};

export const autoBetDataKeys = {
  isAutoBet: 'isAutoBet',
  isOpened: 'isOpened',
  autoBetCount: 'autoBetCount',
};

export const fighterSectionBorderColor = {
  0: 'type-orange',
  1: 'type-green',
  2: 'type-pink',
};

export const autoBetCountList = [5, 10, 20, 50, 99];

export const fightersList = {
  0: { jetNumber: 1, jetName: 'FIGHTER_1', jetColor: 'orange-type', className: 'fighter1' },
  1: { jetNumber: 2, jetName: 'FIGHTER_2', jetColor: 'green-type', className: 'fighter2' },
  2: { jetNumber: 3, jetName: 'FIGHTER_3', jetColor: 'pink-type', className: 'fighter3' },
};

export const betActionName = {
  realBetsCount: 'realBetsCount',
  realBetsCashOutCount: 'realBetsCashOutCount',
  demoBetsCount: 'demoBetsCount',
  demoBetsCashOutCount: 'demoBetsCashOutCount',
};

export const GameAnimationName = {
  Moon: 'moon',
  SkyLoop: 'skyLoop',
  Airplane: 'airplane',
  Asteroid: 'asteroid',
  JetPlane: 'jetPlane',
  SmokeFly: 'smokeFly',
  LaunchPad: 'launchPad',
  JetsGround: 'jetsGround',
  SmokeBrake: 'smokeBrake',
  FightersSky: 'fightersSky',
  JetsFlamesBlue: 'jetsFlamesBlue',
  JetsGroundInner: 'jetsGroundInner',
  JetsFlamesOrange: 'jetsFlamesOrange',
};

export const specificLocalStorageKeys = {
  isShowTutorialPopUps: 'isShowTutorialPopUps',
};
